import Vue from 'vue';
import './plugins/vuetify';
import Vuelidate from 'vuelidate';
import VueYouTubeEmbed from 'vue-youtube-embed';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(Vuelidate);
Vue.use(VueYouTubeEmbed);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  iconfont: 'fa4',
}).$mount('#app');
